import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _categoryStandAlone } from "./optics";
import { _Col2TemplateId } from "@discovery/sonic-api-ng-optics";
import { FeatureStandAloneCategoryView } from "./view";
const getProps = (data) => {
    const categoryStandAlone = Fold.toArray(_categoryStandAlone, data);
    const templateIdM = Fold.preview(_Col2TemplateId, data);
    const templateId = M.fromMaybe(templateIdM, "");
    return {
        categoryStandAlone,
        templateId,
    };
};
const FeaturedStandAlone = ({ categoryStandAlone, templateId }) => templateId === "category" ? (React.createElement(FeatureStandAloneCategoryView, { standAloneData: categoryStandAlone })) : (React.createElement(React.Fragment, null));
export const ComponentMapItem = mkSiteBuilderComponent(getProps, FeaturedStandAlone);

